"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logger = void 0;
var logger = {
  // eslint-disable-next-line no-console
  warn: function warn(msg, scope) {
    return console.warn("[".concat(scope, "]: ").concat(msg));
  }
};
exports.logger = logger;